import { trackEvent } from '@99designs/common/utils/platform';
import { scrollToElement } from 'common/utils/scroll';

export default class CategoriesMenu {
    constructor({ onChange = () => {} }) {
        this.categoryGroups = Array.from(document.querySelectorAll('[data-category-group]'));
        this.categoryMenuButtons = Array.from(document.querySelectorAll('[data-category-menu]'));
        this.categoryMenuTitle = document.querySelector('[data-category-menu-search-title]');
        this.onChange = onChange;
        this.init();
    }

    init() {
        this.categoryMenuButtons.forEach((button, index) => {
            button.addEventListener('click', e => {
                const activeGroupKey = e.currentTarget.getAttribute('data-category-menu');
                this.deactivateMenuButtons();
                e.currentTarget.setAttribute('data-active', true);
                scrollToElement(this.categoryMenuTitle, 10);
                if (activeGroupKey !== 'search') {
                    this.activateCategoryGroup(activeGroupKey);

                    trackEvent('Clicked CategoriesMenu Item', {
                        category: activeGroupKey,
                        index: index,
                    });

                    this.onChange();
                }
            });
        });
    }

    activateCategoryGroup(activeGroupKey) {
        this.categoryGroups.forEach(group => {
            if (group.getAttribute('data-category-group') === activeGroupKey) {
                group.removeAttribute('data-hidden');
                group.setAttribute('data-active', true);
                this.preloadGroupGallery(group);
                this.preloadGroupModalImages(activeGroupKey);
            } else {
                group.setAttribute('data-hidden', true);
                group.removeAttribute('data-active');
            }
        });
    }

    deactivateMenuButtons() {
        this.categoryMenuButtons.forEach(button => button.removeAttribute('data-active'));
    }

    preloadGroupGallery(group) {
        const lazyImages = group.querySelectorAll('img[data-src]');

        Array.from(lazyImages).forEach(image => {
            image.src = image.getAttribute('data-src');
        });
    }

    preloadGroupModalImages(groupKey) {
        const lazyImages = document.querySelectorAll(
            `[data-fullscreen-overlay-category-group="${groupKey}"] img[data-src]`
        );

        Array.from(lazyImages).forEach(image => {
            image.src = image.getAttribute('data-src');
        });
    }
}
